export default __webpack_public_path__ + "static/media/12.7f3d3586.jpg";